import React from "react";
import { GoogleMapsProvider } from "../../components/GoogleMapsProvider";
import ShipmentDetailDrawer from "./ShipmentDetailDrawer";
import { useEffect } from "react";
import EditShipmentDrawer from "./EditShipmentDrawer";
import ShipmentDetailDrawerWithTeams from "./ShipmentDetailDrawerWithTeams";
import EditShipmentDrawerWithTeams from "./EditShipmentDrawerWithTeams";
import ShipmentNotificationDrawer from "./ShipmentNotifications/ShipmentNotificationDrawer";
import { ArrowLeftOutlined } from "@ant-design/icons";

function ShipmentDrawer({
  isOpen,
  name,
  shipmentId,
  toggleDrawer,
  shipmentSuccess,
  token,
  filterByLinkCode,
  onEditShipmentSuccess,
  onCreateShipmentSuccess,
}) {
  useEffect(() => {
    if (isOpen) {
      document.documentElement.classList.add("hide-scrollbar");
    } else {
      document.documentElement.classList.remove("hide-scrollbar");
    }
  }, [isOpen]);

  return (
    <>
      <div className={`custom-card-drawer ${isOpen ? "open" : ""}`}>
        {name === "Detail" ? (
          <GoogleMapsProvider>
            {/* <ShipmentDetailDrawer
              token={token}
              isOpen={isOpen}
              shipmentId={shipmentId}
              toggleDrawer={toggleDrawer}
              shipmentSuccess={shipmentSuccess}
            /> */}

            <ShipmentDetailDrawerWithTeams
              token={token}
              isOpen={isOpen}
              openShipmentId={shipmentId}
              toggleDrawer={toggleDrawer}
              shipmentSuccess={shipmentSuccess}
              filterByLinkCode={filterByLinkCode}
            />
          </GoogleMapsProvider>
        ) : null}

        {name === "Edit" ? (
          // <EditShipmentDrawer
          //   isOpen={isOpen}
          //   shipmentId={shipmentId}
          //   toggleDrawer={toggleDrawer}
          // />
          <EditShipmentDrawerWithTeams
            isOpen={isOpen}
            shipmentId={shipmentId}
            toggleDrawer={toggleDrawer}
             onEditShipmentSuccess={onEditShipmentSuccess}
          />
        ) : null}

        {name === "notifications" ? (
          <ShipmentNotificationDrawer
            isOpen={isOpen}
            shipmentId={shipmentId}
            toggleDrawer={toggleDrawer}
          />
         
        ) : null}
      </div>
    </>
  );
}

export default ShipmentDrawer;
